import { Component, ViewChild, ViewEncapsulation, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SAUTableModule } from '@some-angular-utils/table';
import { SAUModalService } from '@some-angular-utils/modal';
import { AddButtonComponent } from '@/components/add-button/add-button.component';
import { CustomDeleteComponent } from '@/components/custom-delete/custom-delete.component';
import { UserFormComponent } from '../user-form/user-form.component';
import { Urls } from '@/apiConnection/urls';

@Component({
  imports: [
    RouterModule,
    SAUTableModule,
    AddButtonComponent,
  ],
  templateUrl: './users-list.page.html',
  encapsulation: ViewEncapsulation.None,
})
export class UsersListPage {

  @ViewChild('sauTable')
  sauTable: { getItems: () => void; refresh: () => void; } | undefined;

  private sauModalService = inject(SAUModalService);

  url = Urls.urls.users;

  headers = [
    { name: 'Nombre', key: 'name' },
    { name: 'Usuario', key: 'username' },
    { name: 'Email',  key: 'email' },
    { name: 'Rol',    key: 'role.name' },
  ];

  openEditForm(item: { id: number } = { id: 0 }) {
    const modalRef = this.sauModalService.open(UserFormComponent, {});
    modalRef.componentInstance.id = item.id;

    modalRef.componentInstance.acceptFunction.subscribe(() => {
      this.sauTable?.getItems();
    });

    modalRef.componentInstance.closeFunction.subscribe(() => {
      modalRef.dismiss();
    });
  }

  openDeleteForm(item: { id: number } = { id: 0 }) {
    const modalRef = this.sauModalService.open(CustomDeleteComponent, {});
    modalRef.componentInstance.id = item.id;
    modalRef.componentInstance.url = this.url;
    modalRef.componentInstance.item = 'usuario';

    modalRef.componentInstance.acceptFunction.subscribe(() => {
      this.sauTable?.getItems();
    });

    modalRef.componentInstance.closeFunction.subscribe(() => {
      modalRef.dismiss();
    });
  }
}
